// extracted by mini-css-extract-plugin
module.exports = {"container":"HandbookPage-module_container_VhgxY","errorContainer":"HandbookPage-module_errorContainer_Tkyjm","errorIcon":"HandbookPage-module_errorIcon_3_nNW"};